import UserService from 'Services/user';

export default {
	name: 'Plans',
	created() {
		this.isLoading = true;
		this.status = this.$store.state.user.status;
		this.isTrialExpired = this.status === 'cancelled' && this.$store.state.user.plan.trialDays > 0;
		if (this.isTrialExpired) {
			this.title = 'Trial expired';
		}
		this.curPlan = this.$store.state.user.plan.name;
		UserService.getPlans()
			.then(response => {
				this.plans = response.data.plans;
			})
			.catch(error => {
				this.errors.add({
					field: 'apierror',
					msg: error.response.data.Message
				});
			})
			.finally(() => {
				this.isLoading = false;
			});
	},
	data() {
		return {
			isLoading: true,
			status: '',
			isTrialExpired: false,
			curPlan: '',
			isMerchantEnabled: process.env.FEATURE_MERCHANT === 'true',
			plans: [],
			title: 'Upgrade',
			colors: ['#ff780d', '#050a54', '#b00020']
		};
	},
	methods: {
		showEnterprisePlan() {
			return this.plans.length < 3;
		},
		isFreePlan(plan) {
			return plan.plan_name === 'free';
		},
		redirectToSubscribe(plan) {
			if (!this.$store.state.user.isLoggedIn) {
				this.$router.push({ name: 'login', query: { redirect: `/subscription/plan/${plan.plan_name}` } });
			} else {
				this.$router.push({ name: 'subscribe', params: { planName: plan.plan_name } });
			}
		}
	},
	filters: {
		parseCurrency: function (value) {
			if (value.toLowerCase() == 'eur') {
				return '€';
			}
			if (value.toLowerCase() == 'usd') {
				return '$';
			}
			return '€';
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/plans/script.js